export default __webpack_public_path__ + "assets/webgl/scene-6.3d4faffa.glb";